import {
  PASSWORD_REGEX,
  PHONE_REGEX,
  USERNAME_REGEX,
  EMAIL_REGEX,
  USERNAME_EMAIL_REGEX,
} from '@/constants/index'

export const validatePhone = (phoneNumber) => {
  return PHONE_REGEX.test(phoneNumber)
}

export const validatePassword = (password) => {
  return PASSWORD_REGEX.test(password)
}

export const validateUsername = (username) => {
  return USERNAME_REGEX.test(username)
}

export const validateEmail = (email) => {
  return EMAIL_REGEX.test(email)
}

export const validateUsernameOrEmail = (emailOrUsername) => {
  return USERNAME_EMAIL_REGEX.test(emailOrUsername)
}

export function isDate(val: unknown): val is Date {
  return toString.call(val) === '[object Date]'
}

export function isArray<T = unknown>(val: unknown): val is T[] {
  return Array.isArray(val)
}

export function isEmptyArr<T>(
  array: ReadonlyArray<T> | undefined
): array is readonly [] {
  return Array.isArray(array) && array?.length === 0
}

export function isString(val: unknown): val is string {
  return typeof val === 'string'
}

export function isObject(val: unknown): val is Record<string, unknown> {
  return toString.call(val) === '[object Object]' && !Array.isArray(val)
}

export function isEmpty<T = unknown>(val: T): boolean {
  if (!val) {
    return true
  }
  if (isArray(val)) {
    return isEmptyArr(val)
  }

  if (isString(val)) {
    return val.trim().length === 0
  }

  if (val instanceof Map || val instanceof Set) {
    return val.size === 0
  }

  if (isObject(val)) {
    return Object.keys(val).length === 0
  }

  return false
}

export function isNotNull<T>(v: T | null): v is Exclude<T, null> {
  return v !== null
}

export function isDefined<T>(val?: T): val is T {
  return typeof val !== 'undefined'
}
